import { SuppliesTrackableProductType } from "@redotech/cockroachdb-codegen/tables/product/supplies-trackable-product-type";
import { suppliesTrackableProductIdFormat } from "@redotech/redo-marketplace-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const SuppliesTrackableProductTypeSchema = createEnum(
  SuppliesTrackableProductType,
);

// Longest lead time a merchant or admin may set, in days.
export const MAX_LEAD_TIME_DAYS = 10;

const SuppliesTrackableProductSchema_ = z.object({
  id: suppliesTrackableProductIdFormat.schema,
  suppliesProductId: productIdFormat.schema,
  type: SuppliesTrackableProductTypeSchema,
  quantityPerCase: z.bigint(),
  /** Redo-side restock lead time for this SKU, in days. */
  defaultLeadTimeDays: z.bigint(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const SuppliesTrackableProductSchema: z.ZodType<SuppliesTrackableProduct> =
  SuppliesTrackableProductSchema_;
export interface SuppliesTrackableProduct extends z.infer<
  typeof SuppliesTrackableProductSchema_
> {}

/** A trackable product joined to its supplies product, for the admin list. */
const SuppliesTrackableProductDetailSchema_ =
  SuppliesTrackableProductSchema_.extend({
    productTitle: z.string().nullable(),
    productSku: z.string().nullable(),
    imageUrl: z.string().nullable(),
    /** Distinct merchants tracking this product (active or paused config). */
    trackingMerchantCount: z.bigint(),
  });
export const SuppliesTrackableProductDetailSchema: z.ZodType<SuppliesTrackableProductDetail> =
  SuppliesTrackableProductDetailSchema_;
export interface SuppliesTrackableProductDetail extends z.infer<
  typeof SuppliesTrackableProductDetailSchema_
> {}
